import useResizeObserver from '@hooks/use-resize-observer';
import { useCallback, useState } from 'react';

export function useCardSize() {
  const [size, setSize] = useState<'extra-small' | 'small' | 'regular'>('regular');

  const onSizeChange = useCallback(
    (entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        // I provide a slight buffer in between the two width thresholds to avoid flickering
        if (entry.contentBoxSize) {
          if (entry.contentBoxSize[0]) {
            const width = entry.contentBoxSize[0].inlineSize;
            if (width < 260 && size !== 'extra-small') setSize('extra-small');
            else if (width < 335 && width >= 260 && size !== 'small') setSize('small');
            else if (width >= 340 && size !== 'regular') setSize('regular');
          }
        } else {
          const width = entry.contentRect.width;
          if (width < 260 && size !== 'extra-small') setSize('extra-small');
          else if (width < 335 && width >= 260 && size !== 'small') setSize('small');
          else if (width >= 340 && size !== 'regular') setSize('regular');
        }
      }
    },
    [size],
  );

  const resizeRef = useResizeObserver(onSizeChange);

  return { size, resizeRef };
}
